import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { connect } from 'react-redux';
import { loginWithSocial } from 'src/modules/shared/auth/actions';
import signupContext from 'src/constants/signupContext';

import Button from 'src/components/buttons/button';
import { facebookSignupClick, initFacebookSignup } from 'src/utils/facebook';

class FacebookLoginButton extends React.Component {
  static propTypes = {
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool,
    loginWithSocial: PropTypes.func,
    text: PropTypes.string,
    size: PropTypes.oneOf(['sm', 'lg', 'lg-wide']),
    signupContext: PropTypes.object,
  };

  static defaultProps = {
    fullWidth: false,
    disabled: false,
    loginWithSocial: () => {},
    signupContext: {
      element: signupContext.element.FACEBOOK,
      section: signupContext.section.UNTRACKED,
    },
  };

  state = {
    fbReady: false,
  };

  componentDidMount() {
    const { loginWithSocial, signupContext, onSuccess } = this.props;
    initFacebookSignup(
      () => this.setState({ fbReady: true }),
      fbLoginData => loginWithSocial(fbLoginData, 'Facebook', signupContext, onSuccess),
    );
  }

  render() {
    const { text, size, fullWidth, disabled, loginWithSocial, signupContext, onSuccess } = this.props;
    return (
      <Button
        disabled={disabled || !this.state.fbReady}
        fullWidth={fullWidth}
        icon="facebook"
        size={size}
        text={text || i18n.t('Join with Facebook')}
        type="facebook"
        onClick={() => facebookSignupClick(fbLoginData => loginWithSocial(fbLoginData, 'Facebook', signupContext, onSuccess))}
      />
    );
  }
}

export default connect(null, { loginWithSocial })(FacebookLoginButton);



// WEBPACK FOOTER //
// ./src/modules/shared/auth/components/facebookLoginButton.js